/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="emmaAccountSettings.module.ts" />
/// <reference path="../../components/short-cuts/index.d.ts"/>


module Meevo.Plugins.EmmaAccountSettings {

    import ShortCutsStateManagerController = Meevo.Components.ShortCuts.ShortCutsStateManagerController;
    import ShortCutGroup = Meevo.Components.ShortCuts.ShortCutGroup;
    import IShortCutGroup = Meevo.Components.ShortCuts.IShortCutGroup;

    class EmmaAccountSettingsController extends ShortCutsStateManagerController {

        context: EmmaAccountSettingsContext;
        shortCutGroup: IShortCutGroup | { [key: number]: IShortCutGroup };

        get noun() {
            return Meevo.Model.NounEnum.AdvancedMarketingPage;
        }

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "$rootScope",
            "$timeout",
            "$state",
            "meevo.components.tracking.TrackingService",
            "$scope",
            "meevo.components.short-cuts.ShortCutsService",
            "$translate",
            "$window"
        ];

       

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected $rootScope: angular.IRootScopeService,
            protected $timeout: ng.ITimeoutService,
            protected $state: any,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $scope: ng.IScope,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected $translate: angular.translate.ITranslateService,
            protected $window: angular.IWindowService
        ) {
            super($scope, $state, shortCutsService);

            

            this.shortCutGroup = {
                [Meevo.Model.MaintenanceFormState.Readonly]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_EDIT',
                    callback: () => {
                        this.context.edit();
                    }
                }]),
                [Meevo.Model.MaintenanceFormState.Editing]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_SAVE',
                    callback: () => {
                        this.context.save();
                    }

                }, {
                    shortCutName: 'DATA_MAINTENANCE_CANCEL',
                    callback: () => {
                        this.context.cancel();
                    }
                }])
            };

            let vm = this;
            vm.context = new EmmaAccountSettingsContext(appSettings, dataService, modalService, trackingService, identityService, $translate, loggingService, securityService, $window);
            
        }

        
        /**
         * Close current tab
         * */
        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        }
    }

    angular.module('meevo.plugins.emmaAccountSettings')
        .controller('meevo.plugins.emmaAccountSettings.EmmaAccountSettingsController', EmmaAccountSettingsController);
}